export default __webpack_public_path__ + "play.a81a296ed433426e8f86cda791366e3d.svg";